import { CSSProperties } from 'react';

export default function Sms({ s }: { s?: CSSProperties }) {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...s, verticalAlign: 'middle' }}
    >
      <path
        d="M27.48 4.54697H13.3042C12.3633 4.54697 11.5969 5.29766 11.5969 6.22138V33.7786C11.5969 34.7014 12.3633 35.453 13.3042 35.453H27.48C28.4209 35.453 29.1873 34.7014 29.1873 33.7786V6.22138C29.1873 5.29859 28.4219 4.54697 27.48 4.54697ZM22.9805 5.66325L22.8619 5.89022C22.823 5.92278 22.6722 5.9972 22.4351 5.9972H18.35C18.1129 5.9972 17.9621 5.92371 17.9232 5.89022L17.8047 5.66325H22.9805ZM28.0491 33.7786C28.0491 34.0865 27.794 34.3367 27.48 34.3367H13.3042C12.9902 34.3367 12.7351 34.0865 12.7351 33.7786V6.22138C12.7351 5.91348 12.9902 5.66325 13.3042 5.66325H15.9571C16.3478 5.66325 16.5935 5.80557 16.6305 5.86325L16.9179 6.41394C17.1398 6.83906 17.7022 7.11348 18.35 7.11348H22.4351C23.0829 7.11348 23.6454 6.83906 23.8673 6.41394L24.1538 5.86511C24.1907 5.80557 24.4373 5.66325 24.8272 5.66325H27.48C27.794 5.66325 28.0491 5.91348 28.0491 6.22138V33.7786Z"
        fill="#0E1260"
      />
      <path
        d="M24.1888 20.8884H16.5953C16.2814 20.8884 16.0262 21.1386 16.0262 21.4465C16.0262 21.7544 16.2814 22.0046 16.5953 22.0046H24.1888C24.5027 22.0046 24.7579 21.7544 24.7579 21.4465C24.7579 21.1386 24.5027 20.8884 24.1888 20.8884Z"
        fill="#0E1260"
      />
      <path
        d="M24.1888 23.9972H16.5953C16.2814 23.9972 16.0262 24.2474 16.0262 24.5553C16.0262 24.8632 16.2814 25.1135 16.5953 25.1135H24.1888C24.5027 25.1135 24.7579 24.8632 24.7579 24.5553C24.7579 24.2474 24.5027 23.9972 24.1888 23.9972Z"
        fill="#0E1260"
      />
      <path
        d="M24.1888 27.1051H16.5953C16.2814 27.1051 16.0262 27.3553 16.0262 27.6632C16.0262 27.9711 16.2814 28.2214 16.5953 28.2214H24.1888C24.5027 28.2214 24.7579 27.9711 24.7579 27.6632C24.7579 27.3553 24.5027 27.1051 24.1888 27.1051Z"
        fill="#0E1260"
      />
      <path
        d="M24.1613 32.5088H16.6228C16.3089 32.5088 16.0537 32.7591 16.0537 33.067C16.0537 33.3749 16.3089 33.6251 16.6228 33.6251H24.1613C24.4752 33.6251 24.7303 33.3749 24.7303 33.067C24.7303 32.7591 24.4752 32.5088 24.1613 32.5088Z"
        fill="#21A1D8"
      />
      <path
        d="M24.1888 11.3683H16.5953C16.2814 11.3683 16.0262 11.6186 16.0262 11.9265V18.1432C16.0262 18.4511 16.2814 18.7014 16.5953 18.7014H24.1888C24.5027 18.7014 24.7579 18.4511 24.7579 18.1432V11.9265C24.7579 11.6186 24.5027 11.3683 24.1888 11.3683ZM23.6197 17.5851H17.1644V12.4846H23.6197V17.5851Z"
        fill="#21A1D8"
      />
    </svg>
  );
}
